import { Onboardings } from 'src/components/onboarding/onboardings/Onboardings'
import React from 'react'
import { ReloadWrapper } from 'src/components/wrapper/reload-wrapper/ReloadWrapper'

export const OnboardingsPage = () => {
  return (
    <ReloadWrapper>
      <div data-testid="dashboard-onboardings-page">
        <Onboardings />
      </div>
    </ReloadWrapper>
  )
}
